/**
 * @generated SignedSource<<673faebfde2e9fae67c6cf08262f0207>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOktaVerificationKeyInput = {
  email?: string | null;
  issuer?: string | null;
  clientMutationId?: string | null;
};
export type createOktaVerificationKeyMutation$variables = {
  input: CreateOktaVerificationKeyInput;
};
export type createOktaVerificationKeyMutation$data = {
  readonly createOktaVerificationKey: {
    readonly key: string | null;
    readonly oktaClientId: string | null;
    readonly oktaUrl: string | null;
    readonly oktaDomainSuffix: string | null;
  } | null;
};
export type createOktaVerificationKeyMutation = {
  variables: createOktaVerificationKeyMutation$variables;
  response: createOktaVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOktaVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOktaVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaDomainSuffix",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "195b93b98d8154349baea7763c910d34",
    "id": null,
    "metadata": {},
    "name": "createOktaVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOktaVerificationKeyMutation(\n  $input: CreateOktaVerificationKeyInput!\n) {\n  createOktaVerificationKey(input: $input) {\n    key\n    oktaClientId\n    oktaUrl\n    oktaDomainSuffix\n  }\n}\n"
  }
};
})();

(node as any).hash = "71b4672621f2bddfaa4aeadc4eb27fc1";

export default node;
